import { reportException } from './exception';

// Vue 无组件实例的 fallback 无法访问 app.errorHandler，需桥接到安全上报入口。
window.__ABC_REPORT_VUE_ERROR__ = reportException;
